import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import aboutUs from "@/components/aboutUs"
import activityDetail from '@/components/activityview/activityDetail'
import team from '@/components/activityview/team'
import signUp from '@/components/activityview/signUp'
import activityIndex from '@/components/activityview/activityIndex'
import leaderList from '@/components/leaderview/leaderList'
import leaderDetail from '@/components/leaderview/leaderDetail'
import introductionList from '@/components/Introductionview/introductionList'  
import introductionDetail from '@/components/Introductionview/introductionDetail' 
import userindex from '@/components/userview/userindex'
import searchActivity from '@/components/activityview/searchActivity'
import serviceAgreement from '@/components/userview/serviceAgreement'
import wx from '@/components/wx'
import login from '@/components/login'
import adDetails from '@/components/home/adDetails'

Vue.use(Router)

export default new Router({
  // mode:'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path:'/adDetails',
      name:'adDetails',
      component: adDetails
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/activityDetail',
      name: 'activityDetail',
      component: activityDetail
    },
    {
      path: '/team',
      name: 'team',
      component: team
    },

    
    {
      path: '/activityIndex',
      name: 'activityIndex',
      component: activityIndex
    },
    {
      path: '/leaderList',
      name: 'leaderList',
      component: leaderList
    },
    {
      path: '/leaderDetail',
      name: 'leaderDetail',
      component: leaderDetail
    },
    {
      path: '/introductionList',
      name: 'introductionList',
      component: introductionList
    },
    {
      path: '/introductionDetail',
      name: 'introductionDetail',
      component: introductionDetail
    },
    {
      path: '/userindex/:id',
      name: 'userindex',
      component: userindex
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: signUp
    },
    {
      path: '/searchActivity',
      name: 'searchActivity',
      component: searchActivity
    },
    {
      path: '/serviceAgreement',
      name: 'serviceAgreement',
      component: serviceAgreement
    },
    {
      path: '/wx',
      name: 'wx',
      component: wx
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },

    // {
    //   path: '/distributionDetail',
    //   name: 'distributionDetail',
    //   component: distributionDetail
    // },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js